import React from 'react';
import PropTypes from 'prop-types';

import MenuSection from './components/MenuSection';
import MenuNavigation from './components/MenuNavigation';

export default class Menu extends React.Component {
  render() {
    const {
      centerHeaders,
      imageSize,
      menuItems,
      itemsPerRow,
      itemAs,
      displayCategoriesAs,
      sectionAsAccordion,
      showMenuNavigation,
      menuNavigationDivided,
    } = this.props;

    return (
      <div>
        <MenuNavigation
          categories={menuItems.map(({ categoryTitle }) => categoryTitle)}
          displayCategoriesAs={displayCategoriesAs}
          showMenuNavigation={showMenuNavigation}
          menuNavigationDivided={menuNavigationDivided}
        />
        {menuItems.map(({ categoryTitle, categoryDescription, categoryItems }) => (
          <MenuSection
            key={categoryTitle}
            asAccordion={sectionAsAccordion}
            centerHeaders={centerHeaders}
            imageSize={imageSize}
            itemAs={itemAs}
            itemsPerRow={itemsPerRow}
            sectionTitle={categoryTitle}
            sectionDescription={categoryDescription}
            sectionItems={categoryItems}
          />
        ))}
      </div>
    );
  }
}

Menu.propTypes = {
  menuItems: PropTypes.arrayOf(
    PropTypes.shape({
      categoryTitle: PropTypes.string,
      categoryDescription: PropTypes.string,
      categoryItems: PropTypes.arrayOf(
        PropTypes.shape({
          itemThumbnail: PropTypes.string,
          itemPrice: PropTypes.string,
          itemTitle: PropTypes.string.isRequired,
          itemDescription: PropTypes.string,
          itemNote: PropTypes.string,
          itemLabels: PropTypes.arrayOf(PropTypes.string),
          labelAsImage: PropTypes.bool,
          itemCTALink: PropTypes.string,
        }),
      ),
    }),
  ).isRequired,
  centerHeaders: PropTypes.bool,
  displayCategoriesAs: PropTypes.oneOf(['button', 'text', 'header']),
  sectionAsAccordion: PropTypes.bool,
  itemAs: PropTypes.oneOf(['Item', 'Card']),
  imageSize: PropTypes.string,
  itemsPerRow: PropTypes.number,
  menuNavigationDivided: PropTypes.bool,
  showMenuNavigation: PropTypes.bool,
};

Menu.defaultProps = {
  centerHeaders: true,
  displayCategoriesAs: 'button',
  sectionAsAccordion: false,
  itemAs: 'Item',
  imageSize: 'small',
  itemsPerRow: 2,
  menuNavigationDivided: false,
  showMenuNavigation: true,
};

Menu.propOptions = {};

Menu.dataPropsMap = {};
